var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricingIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 190,
    viewBox: "0 0 208 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3021_12444)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M105.189 189.191C161.97 189.191 208 182.759 208 174.824C208 166.889 161.97 160.457 105.189 160.457C48.4073 160.457 2.37708 166.889 2.37708 174.824C2.37708 182.759 48.4073 189.191 105.189 189.191Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M158.228 8.92883H41.8228V157.144H158.228V8.92883Z",
    fill: "#80B4E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M143.862 19.8119H54.4811V51.0639H143.862V19.8119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M119.176 58.7894H100.211V74.8203H119.176V58.7894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M59.5919 38.5393C59.5919 38.5393 64.0491 39.5942 62.6376 47.045C61.2262 54.4959 58.1805 58.4553 59.4656 61.4267C60.7508 64.3982 78.0371 58.9456 88.4371 73.8027C98.8371 88.6599 107.751 107.484 90.1679 105.998C72.5845 104.512 65.6536 108.539 66.1513 120.759C66.6491 132.979 85.8742 166.073 85.8742 166.073H42.6028L45.2176 107.759L55.2611 43.2639L59.5919 38.5393Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M94.7811 58.7894H75.8159V74.8203H94.7811V58.7894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2861 67.7037H50.3209V83.7346H69.2861V67.7037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M119.176 82.806H100.211V98.8369H119.176V82.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M94.7811 82.806H75.8159V98.8369H94.7811V82.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M69.2861 82.806H50.3209V98.8369H69.2861V82.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M118.976 105.983H100.011V122.014H118.976V105.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M94.5804 105.983H75.6152V122.014H94.5804V105.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M94.5804 127.771H75.6152V143.802H94.5804V127.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M69.0857 105.983H50.1206V122.014H69.0857V105.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.641 63.7965C71.641 63.7965 101.11 86.7211 93.1096 106.028C92.7255 106.967 92.1016 107.79 91.3003 108.413C90.499 109.036 89.5482 109.438 88.543 109.578C87.5378 109.719 86.5133 109.593 85.5718 109.214C84.6303 108.835 83.8047 108.215 83.1776 107.417L68.5284 88.6005L71.641 63.7965Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M71.641 63.7965C71.641 63.7965 101.11 86.7211 93.1096 106.028C92.7255 106.967 92.1016 107.79 91.3003 108.413C90.499 109.036 89.5482 109.438 88.543 109.578C87.5378 109.719 86.5133 109.593 85.5718 109.214C84.6303 108.835 83.8047 108.215 83.1776 107.417L68.5284 88.6005L71.641 63.7965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0764 163.087C71.0764 163.087 72.1164 164.966 73.9439 164.825C75.7713 164.684 76.5364 166.378 74.9839 167.098C73.4313 167.819 68.9147 166.415 68.9147 166.415L68.5284 163.087H71.0764Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6918 163.087C42.6918 163.087 43.7318 164.966 45.5592 164.825C47.3867 164.684 48.1518 166.378 46.5992 167.098C45.0467 167.819 40.5375 166.415 40.5375 166.415L40.1438 163.087H42.6918Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8907 44.7793C58.119 46.8267 58.0715 48.8954 57.7496 50.9302C57.6961 51.1691 57.5959 51.395 57.4547 51.595C57.3136 51.795 57.1344 51.9651 56.9272 52.0956C56.7201 52.2261 56.4893 52.3143 56.2479 52.3553C56.0066 52.3962 55.7595 52.3891 55.521 52.3342C54.746 52.2047 54.0243 51.8561 53.4412 51.3295C52.858 50.803 52.4378 50.1205 52.2301 49.3628L51.0416 46.1536C50.8705 45.4869 50.9109 44.7835 51.1571 44.1407C51.4033 43.4979 51.8431 42.9475 52.4158 42.5656C54.4884 40.9759 57.7496 42.5285 57.8907 44.7793Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7176 47.0306L48.7164 58.7901L55.3204 59.9786L54.8524 50.9381L51.7176 47.0306Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.633 48.9984C50.6332 49.0773 50.6607 49.1537 50.7108 49.2146C50.7609 49.2756 50.8305 49.3173 50.9079 49.3327C51.4262 49.4652 51.9736 49.426 52.4678 49.2211C52.962 49.0162 53.3765 48.6565 53.649 48.1962C53.9657 47.6842 54.126 47.0909 54.1101 46.4891C54.0943 45.8874 53.9031 45.3033 53.5599 44.8087C54.6882 44.9998 55.8352 45.0572 56.977 44.9796C57.3625 44.9592 57.7417 44.8738 58.0987 44.727L58.9827 41.919C58.9827 41.919 60.4684 39.1036 58.7822 38.5464C57.0959 37.9893 56.405 39.8687 55.0679 38.5464C53.7307 37.2242 53.3964 36.7264 52.037 37.4842C50.6776 38.2419 52.2599 39.2819 50.0313 39.319C47.8027 39.3562 47.7507 40.2699 47.7507 41.295C47.8024 41.6445 47.9577 41.9706 48.1964 42.231C49.7184 44.1644 50.5732 46.5386 50.633 48.9984Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0428 48.055C54.0428 48.055 53.976 46.6287 52.9062 46.7624C51.8365 46.8961 51.9182 48.991 53.3817 49.1172L54.0428 48.055Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0319 47.1119L59.1017 48.5159C59.1631 48.5945 59.2035 48.6874 59.2191 48.7858C59.2347 48.8843 59.2249 48.9852 59.1907 49.0788C59.1565 49.1725 59.099 49.2559 59.0237 49.3212C58.9483 49.3865 58.8575 49.4315 58.7599 49.4519L57.3485 49.7565L58.0319 47.1119Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M54.8896 52.1483C54.8896 52.1483 54.0428 51.9998 52.5125 50.618C52.5125 50.618 52.2896 53.0249 55.053 54.8003L54.8896 52.1483Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6805 62.8832C26.8167 60.8795 28.4702 59.2178 30.4683 58.0718C32.4663 56.9257 34.7356 56.3374 37.0388 56.3683C46.3022 56.4501 63.1279 57.5272 71.6411 63.7969C83.7793 72.7112 77.5839 85.0872 67.4365 98.7112C57.2891 112.335 57.3485 120.744 57.3485 120.744L31.5268 119.511C31.5268 119.511 13.1856 85.1615 25.6805 62.8832Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5269 119.511L40.9389 139.813L39.208 163.087H43.9103L49.5337 144.114C50.4513 141.046 50.4513 137.777 49.5337 134.71L46.6663 125.201L57.3783 120.744L31.5269 119.511Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3484 120.744L72.8815 163.087H66.6935C66.6935 163.087 54.1616 134.212 44.4078 126.939V124.213L57.3484 120.744Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M42.6027 63.7965C42.6027 63.7965 46.9558 77.6582 38.7844 86.3422C30.613 95.0262 36.1472 113.36 41.273 119.979L32.2547 119.511C32.2547 119.511 22.4341 106.139 21.3495 82.9474C20.265 59.7554 42.6027 63.7965 42.6027 63.7965Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6963 69.2417C44.8981 62.816 39.3935 55.4023 32.2992 56.4794C20.4135 58.2623 3.2609 64.4651 0.445476 85.1834C-3.92995 117.334 26.8169 118.716 26.8169 118.716L27.4929 114.898C27.4929 114.898 20.1683 111.339 15.3695 104.795C9.31519 96.5788 13.6312 84.7971 23.4963 82.1897C29.9741 80.4886 37.8855 76.8783 41.6963 69.2417Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M41.6963 69.2417C44.8981 62.816 39.3935 55.4023 32.2992 56.4794C20.4135 58.2623 3.2609 64.4651 0.445476 85.1834C-3.92995 117.334 26.8169 118.716 26.8169 118.716L27.4929 114.898C27.4929 114.898 20.1683 111.339 15.3695 104.795C9.31519 96.5788 13.6312 84.7971 23.4963 82.1897C29.9741 80.4886 37.8855 76.8783 41.6963 69.2417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.493 114.898C27.493 114.898 33.2576 114.838 32.1062 120.744C30.9547 126.65 26.817 118.716 26.817 118.716L27.493 114.898Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4203 69.5904L59.575 66.7338L55.1886 81.8514L65.034 84.708L69.4203 69.5904Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M58.2845 82.7466C58.2845 82.7466 58.7823 76.1426 65.3714 78.2448L65.0371 84.7003L58.2845 82.7466Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3662 108.547C85.3048 109.179 86.4274 109.48 87.5565 109.403C88.6856 109.326 89.7567 108.874 90.6004 108.12C91.4442 107.366 92.0124 106.352 92.2152 105.238C92.4181 104.125 92.244 102.976 91.7205 101.972C90.436 99.6307 88.7076 97.5617 86.6319 95.881C76.3062 87.0707 70.3856 83.8021 70.3856 83.8021L66.1885 86.7736C66.1885 86.7736 73.5428 101.46 84.3662 108.547Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M84.3662 108.547C85.3048 109.179 86.4274 109.48 87.5565 109.403C88.6856 109.326 89.7567 108.874 90.6004 108.12C91.4442 107.366 92.0124 106.352 92.2152 105.238C92.4181 104.125 92.244 102.976 91.7205 101.972C90.436 99.6307 88.7076 97.5617 86.6319 95.881C76.3062 87.0707 70.3856 83.8021 70.3856 83.8021L66.1885 86.7736C66.1885 86.7736 73.5428 101.46 84.3662 108.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3856 83.8015C70.3856 83.8015 67.9714 78.9878 65.3714 78.245C62.7714 77.5021 60.8548 81.5581 66.7679 86.3421L70.3856 83.8015Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M143.869 58.7894H124.904V74.8203H143.869V58.7894Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M143.869 82.806H124.904V98.8369H143.869V82.806Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M143.869 105.983H124.904V145.236H143.869V105.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.012 0H134.383V29.7143H181.012V0Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.171 43.4644H118.976V47.4535H138.171V43.4644Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M138.171 36.2288H118.976V40.2179H138.171V36.2288Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.908 17.3751H143.587V23.6968H149.908V17.3751Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.561 10.5785H154.239V23.6973H160.561V10.5785Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.808 6.00964H165.486V23.6971H171.808V6.00964Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M158.229 29.7288H134.383V37.8408H158.229V29.7288Z",
    fill: "#29333D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M179.905 156.601C179.905 156.601 173.063 154.737 171.57 148.363C171.57 148.363 182.178 146.224 182.475 157.166L179.905 156.601Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M180.774 155.91C180.774 155.91 175.99 148.348 180.202 141.284C180.202 141.284 188.262 146.402 184.659 155.925L180.774 155.91Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.978 155.91C181.978 155.91 184.503 147.925 192.14 146.417C192.14 146.417 193.566 151.617 187.193 155.925L181.978 155.91Z",
    fill: "#016AD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.015 155.748L178.397 165.241L187.133 165.278L188.426 155.8L177.015 155.748Z",
    fill: "#29333D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3021_12444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 189.429,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIllustration);
export default __webpack_public_path__ + "static/media/pricing-Illustration.706385bfdf458bb75fb4441c99d4f758.svg";
export { ForwardRef as ReactComponent };